export const DEVICES_SET = 'DEVICES_SET';
export const DEVICES_ERROR = 'DEVICES_ERROR';
export const DEVICES_TOGGLE_LOADING = 'DEVICES_TOGGLE_LOADING';
export const DEVICES_TOGGLE_FILTERS = 'DEVICES_TOGGLE_FILTERS';
export const DEVICES_HISTORY_SET = 'DEVICES_HISTORY_SET';
export const DEVICES_RESET = 'DEVICES_RESET';
